// O que ocupa um horário na agenda.
//
// O nó `cise/availability/{teacherId}/bookings/{data}/{hora}` guarda duas coisas
// bem diferentes no mesmo lugar: o agendamento definitivo e a reserva temporária
// que a Nalla cria enquanto negocia o horário com o lead.
//
// A regra de reconhecimento espelha a da engine: vale o `lockKind`, e também o
// `nome` contendo "negocia" — porque o painel antigo gravava a reserva só pelo
// nome, sem o campo estruturado.

export const NEGOTIATION = "NEGOTIATION";

function deaccentLower(value) {
    return String(value || "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase();
}

export function isNegotiationLock(booking) {
    if (!booking || typeof booking !== "object") return false;
    if (String(booking.lockKind || "").toUpperCase() === NEGOTIATION) return true;
    return deaccentLower(booking.nome).includes("negocia");
}

// Reserva sem validade é reserva órfã: conta como vencida.
export function isLockExpired(booking, now = Date.now()) {
    if (!isNegotiationLock(booking)) return false;
    const expiresAt = Number(booking.expiresAt);
    if (!Number.isFinite(expiresAt) || expiresAt <= 0) return true;
    return expiresAt <= now;
}

/**
 * Classifica o que está gravado no horário.
 * @returns {"booking"|"negotiation"|"expired"} — "expired" significa livre na prática
 */
export function classifyBooking(booking, now = Date.now()) {
    if (!isNegotiationLock(booking)) return "booking";
    return isLockExpired(booking, now) ? "expired" : "negotiation";
}

// Quanto tempo resta na reserva, para mostrar na grade.
export function lockRemainingLabel(booking, now = Date.now()) {
    const expiresAt = Number(booking?.expiresAt);
    if (!Number.isFinite(expiresAt) || expiresAt <= now) return null;
    const minutes = Math.ceil((expiresAt - now) / 60000);
    return minutes <= 1 ? "expira em menos de 1 min" : `expira em ${minutes} min`;
}
